exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-multi-select[data-v-4f65b028]{position:relative;display:inline-block;width:200px}.checkbox-header[data-v-4f65b028]{background-color:#f1f1f1;padding:8px;cursor:pointer;border:1px solid #ccc;border-radius:4px}.checkbox-dropdown[data-v-4f65b028]{position:absolute;background-color:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:0 2px 5px rgba(0,0,0,.2);width:100%;z-index:10;max-height:200px;overflow-y:auto}.checkbox-item[data-v-4f65b028]{padding:8px}.checkbox-item[data-v-4f65b028]:hover{background-color:#f0f0f0}.checkbox-item input[data-v-4f65b028]{margin-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f65b028","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/CheckboxMultiSelect.vue
// module id = 1594
// module chunks = 0